import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";

const KEY = "cp_cart";
const Ctx = createContext(null);

const read = () => {
  try { const v = JSON.parse(localStorage.getItem(KEY) || "[]"); return Array.isArray(v) ? v.filter((l) => l?.id && l.qty > 0) : []; }
  catch { return []; }
};

export const isUnique = (a) => (typeof a?.unique === "boolean" ? a.unique : a?.cat !== "autre");
export const stockOf = (a) => (isUnique(a) || typeof a?.stock !== "number" ? null : a.stock);
export const maxQty = (a) => { const s = stockOf(a); return s === null ? 20 : Math.min(20, s); };

export const CartProvider = ({ children }) => {
  const [lines, setLines] = useState(read);
  const [open, setOpen] = useState(false);
  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(lines)); }, [lines]);

  const add = useCallback((a) => {
    setLines((p) => {
      const ex = p.find((l) => l.id === a.id);
      if (ex) return isUnique(a) ? p : p.map((l) => (l.id === a.id ? { ...l, qty: Math.min(maxQty(a), l.qty + 1) } : l));
      return [...p, { id: a.id, qty: 1 }];
    });
  }, []);
  const setQty = useCallback((id, qty) => setLines((p) => p.map((l) => (l.id === id ? { ...l, qty: Math.max(1, Math.min(20, qty)) } : l))), []);
  const remove = useCallback((id) => setLines((p) => p.filter((l) => l.id !== id)), []);
  const clear = useCallback(() => setLines([]), []);
  const count = lines.reduce((s, l) => s + l.qty, 0);
  const has = useCallback((id) => lines.some((l) => l.id === id), [lines]);

  const value = useMemo(() => ({ lines, add, setQty, remove, clear, count, has, open, setOpen }), [lines, add, setQty, remove, clear, count, has, open]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
};

export const useCart = () => useContext(Ctx);
